


import React, { FunctionComponent, useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Divider,
  Grid,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';

import { getAccountAction, useAccount, } from '@ivymobi/orbit-core/business/tenant';
import { getStatsAction, useStats } from '@ivymobi/orbit-core/business/stats';
import { getDocumentThumb, getFileType, Tenant } from '@ivymobi/orbit-core';
import QuickStart from '../dashboard/quickStart';
import Title from '../components/views/title';
import Menus, { OpenMenuItem } from '../components/views/menuItem';
import { getAllCatalogsAction, getArticlesById, getCatlogsAction, getControlsAction, getProductSelectionCgIDAction, getProductSelectionRobotAction, getRobotLocalesAction, useModelOptions } from '@ivymobi/orbit-core/business/productCenter';
import { filter, isUndefined, union } from 'lodash';
import { DeviceType, InnerUserContext, UserContext, WebSiteContext } from '../orbit-context';
import ZTree from './component/zTree';
import './selections.css'
import RobotSearch from './component/robotSearch';
import ProductItem from './component/productItem';
import { Favorite, Share } from '@mui/icons-material';
import { TabPanel } from '../components';
import { IvymobiTabs } from '../components/IvymobiTabs';
import SelectionItem from './component/selectionItem';
import _ from 'lodash';
import { el } from 'date-fns/locale';
import { modelOptionsAction, useOptions } from '@ivymobi/orbit-core/business/user';
import ControlPanel from './component/controlPanel';
import { getOutLibDocumentsAction, userShareEvent } from '@ivymobi/orbit-core/business/share';
import { DocumentGridCard } from '../documents/grid';
import { getTitle, getTitleById } from './mapping';
import fullTexts from './fullTexts';
import RichText from '../components/richText/RichTextRenderer';

const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    overflow:'auto',
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)  },


}));

export const AboutView = (props) => {
  const dispatch = useDispatch();
  const innerUser = useContext(InnerUserContext);
  const {user, token} = useContext(UserContext);

  const deviceType = useContext(DeviceType);
  const [infos,setInfos] = useState(null)
  const classes = useStyles(); 
  const { webInfo } = useContext(WebSiteContext);

  const getAbout =()=>{
   

    for(let i=0;i<fullTexts.length;i++){
      let _text = fullTexts[i];
      
      if(_text.name==='关于三菱电机'){
        console.log("==================",_text)
        return _text.children;
      }
    }
  }
  useEffect(()=>{
    props.setTitle('关于三菱电机')
    props.setParents([])
    const threeLevelCase = new Promise((resolve) => {
      resolve(dispatch(getArticlesById({user:{token:null, user:null}, tenant:{id: webInfo.tnt_id}, id: 'c3dcf392-f46d-49b6-89ae-18b0bdd6dcfb'})));
    });
    threeLevelCase.then((res: string[]) => {
      setInfos(res.data[0]);
      dispatch(userShareEvent({user:{user:{id:innerUser?.userId??user?.id}}, share:{tenantId:webInfo.tnt_id,id:'11111111-1111-1111-1111-111111111111',memberId:innerUser?.memberId}, document:{id:res.data?.[0]?.id,type:'article'}, type:'view', detail:null}));

    });

  },[])
  // let abouts = getAbout();
  return (
    <div style={{height:deviceType==='computer'?'calc(100% - 30px)':'100%'}}>
      {deviceType==='computer'&&<Breadcrumbs style={{height:'30px'}} separator=">" maxItems={8}>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={'/'}
          component={RouteLink}
        >
          首页
        </Link>
        <Link
        //   key={b.id}
          color='textPrimary'
          to={null}
          component={RouteLink}
        >
          关于三菱电机
        </Link>
      </Breadcrumbs>}
      <Box className={classes.pages}>
        <Box style={{width:deviceType==='computer'?'80%':'100%',maxWidth:'1000px',paddingTop:'10px',paddingBottom:'16px',height:'100%',display:'flex',flexDirection:'column',background:'white',padding:'20px',overflow:'auto'}}> 
        <Box style={{display:'flex',justifyContent:'center'}}>
        <div style={{width:'100%',overflow:'auto'}} dangerouslySetInnerHTML={{__html:infos?.info}}></div>

        </Box>
          
        </Box>
        

      </Box>
    </div>
  );
};


export default function AboutContainer (props) {

  return (
    <AboutView {...props}

    />
  );
}